import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

export const StepCardContainer = styled(motion.div)(() => ({
  flexBasis: 0,
  flexGrow: 1,
  backgroundColor: '#FFFFFF',
  borderRadius: '0.75rem',
  height: '9.375rem',
  minWidth: '14.375rem',
  maxWidth: '25rem',
  padding: '0.75rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '0.75rem',

  boxShadow: '0px 2px 0.5rem rgba(0,0,0,0.05)',
  cursor: 'default',
}));

export const Badge = styled(Box)({
  backgroundColor: '#EBF1FF',
  padding: '0.5rem 1rem',
  borderRadius: '9999px',
  display: 'inline-flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
});

export const BadgeText = styled(Typography)({
  fontFamily: '"Rookery new", sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  letterSpacing: '0.00625rem',
  color: '#161c27',
});

export const CardContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
});

export const CardTitle = styled(Typography)({
  fontFamily: '"Rookery new", sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  letterSpacing: '0.00625rem',
  color: '#161c27',
  fontWeight: 500,
});

export const CardDesc = styled(Typography)({
  fontFamily: '"Rookery new", sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1rem',
  color: '#5f5e60',
});
